import { FileIcon } from "@msuite/ui/file-upload";
import { useLoading } from "@msuite/ui/hooks";
import { Loading } from "@msuite/ui/loading-screen";
import { responseHandler } from "@msuite/ui/utils";
import type { PartnerTimelineInvoiceTrackingItem } from "@msuite/utils/types";
import { client } from "@/hono";

/** Props Interface */
interface PartnerTimelineInvoiceTrackingReportProps {
	item: PartnerTimelineInvoiceTrackingItem;
}

export function PartnerTimelineInvoiceTrackingReport({
	item,
}: PartnerTimelineInvoiceTrackingReportProps) {
	/** Hooks */
	const loader = useLoading();

	/** Functions */
	async function handleOpenReport() {
		try {
			loader.start();
			const response = await client.files[":fileId"].$get({
				param: { fileId: item.fileId },
			});
			const data = await responseHandler(response);
			if (!data.success) return;
			if (!data.signedUrl) return;
			window.open(data.signedUrl, "_blank");
		} catch (error) {
			console.error(error);
		} finally {
			loader.stop();
		}
	}

	/** Render */
	return (
		<button
			type="button"
			className="h-stack gap-2 flex-nowrap"
			onClick={handleOpenReport}
		>
			<Loading isLoading={loader.isLoading}>
				<FileIcon
					fileType="application/pdf"
					size={12}
				/>
				<p className="tabular-nums link">{item.reportNumber}</p>
			</Loading>
		</button>
	);
}
